export const environment = {
    cbmsAPIUrl: 'https://api.dev.cbms.eon-optimum.com',
    // cbmsAPIUrl: 'http://localhost:8080',
    name: 'development',
    production: false,
    dashboardsAppUrl: 'https://dashboard.dev.cbms.eon-optimum.com'
};
